import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import { pixelCorners } from '../pixel/pixelUI'

const BottomBar = styled(motion.div)`
  position: fixed;
  bottom: 1.2rem;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 20;
  pointer-events: none;

  @media (max-width: 600px) {
    position: absolute;
    top: 5.8rem;
    bottom: auto;
    padding: 0 0.5rem;
  }
`

const NavContainer = styled.div`
  pointer-events: all;
  display: flex;
  gap: 0.8rem;
  background: #fff;
  border: 4px solid ${(props) => props.theme.black};
  padding: 0.6rem;
  ${pixelCorners(8)}

  @media (max-width: 600px) {
    width: min(100%, 22rem);
    justify-content: center;
    gap: 0.35rem;
    padding: 0.4rem;
  }
`

const NavItem = styled(NavLink)`
  font-family: ${(props) => props.theme.pixelFont};
  font-size: 0.7rem;
  text-decoration: none;
  color: ${(props) => props.theme.black};
  background: ${(props) => props.$bg};
  border: 3px solid ${(props) => props.theme.black};
  padding: 0.8rem 1.1rem;
  ${pixelCorners(5)}
  transition: transform 0.1s ease;

  @media (max-width: 600px) {
    flex: 1;
    text-align: center;
    font-size: 0.55rem;
    padding: 0.7rem 0.45rem;
  }

  &:hover {
    transform: translateY(-3px);
  }

  &.active {
    outline: 3px solid ${(props) => props.theme.black};
    outline-offset: 2px;
  }
`

const navVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 22, staggerChildren: 0.08 },
  },
}

const NavigationBar = () => {
  return (
    <BottomBar variants={navVariants} initial="hidden" animate="visible">
      <NavContainer>
        <NavItem to="/" end $bg="#FFD93D">Home</NavItem>
        <NavItem to="/work" $bg="#FF3E8E" style={{ color: '#fff' }}>Project</NavItem>
        <NavItem to="/skills" $bg="#4FC9FF">Skill</NavItem>
      </NavContainer>
    </BottomBar>
  )
}

export default NavigationBar
